import quizNight from "../data/game-definitions/quiz-night.json";
import whoInTheRoom from "../data/game-definitions/who-in-the-room.json";
import { validateGameDefinition } from "./validateGameDefinition";
import type { GameDefinition } from "./types";

export type GameDefinitionResult =
  | { status: "ready"; definition: GameDefinition }
  | { status: "invalid"; errors: string[] }
  | { status: "unsupported" };

const rawDefinitions: Readonly<Record<string, unknown>> = {
  "quiz-night": quizNight,
  "who-in-the-room": whoInTheRoom,
};

const validatedDefinitions = Object.fromEntries(
  Object.entries(rawDefinitions).map(([gameId, definition]) => {
    const result = validateGameDefinition(definition);
    return [gameId, result];
  }),
);

export const supportedGameIds = Object.freeze(Object.keys(rawDefinitions));

export function getGameDefinition(gameId: string): GameDefinitionResult {
  const result = validatedDefinitions[gameId];

  if (!result) {
    return { status: "unsupported" };
  }

  return result.success
    ? { status: "ready", definition: result.data }
    : { status: "invalid", errors: result.errors };
}

export function isGameSimulationSupported(gameId: string): boolean {
  return getGameDefinition(gameId).status === "ready";
}
